import { render, staticRenderFns } from "./ClockDigital.vue?vue&type=template&id=a81b3d90&scoped=true&"
import script from "./ClockDigital.vue?vue&type=script&lang=js&"
export * from "./ClockDigital.vue?vue&type=script&lang=js&"
import style0 from "./ClockDigital.vue?vue&type=style&index=0&id=a81b3d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81b3d90",
  null
  
)

export default component.exports